module.exports = __webpack_public_path__ + "static/Homestay-81569d2b752c0186bb82daac581ba901.gif";